import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityStageListDetails = () => {
  const columns = [
    { label: 'Stage Name', value: 'name' },
    { label: 'Order', value: 'order' },
    {
      label: 'Access Details',
      value: (stageId) => (
        <button onClick={() => handleAccessDetails(stageId)}>Access Details</button>
      ),
    },
  ];

  const handleAccessDetails = (stageId) => {
    // Handle access details action, navigating to the single stage view
    //console.log('Access Details', stageId);
    const encodedId = btoa(stageId);
    window.location.href = `/opportunity-stage/details/${encodedId}`;
  };

  return (
    <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES.opportunityStage} columns={columns} onAccessDetails={handleAccessDetails} />
  );
};

export default OpportunityStageListDetails;
